export default "/images/vendor/flag-icon-css/flags/1x1/sx.svg?ce647f25cbbcdb00ed0d4be53bff5d32";